import React from "react";
import classnames from "classnames";
import NotificationAlertOptions from "@/layouts/Alerts";
import {
  Button,
  Row,
  Col,
  InputGroup,
  Input,
  Label,
  FormGroup,
} from "reactstrap";

type PropertyDraft = {
  name?: string;
  description?: string;
  type?: string;
  order_listing?: number | string;
  order_product?: number | string;
};

type UpdatePropertiesViewProps = {
  draft: PropertyDraft;
  siteShowChecked: boolean;
  siteBoxChecked: boolean;
  onChangeUpdateInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeCheckboxShow: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeCheckboxBox: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickUpdate: () => void;
};

export default function UpdatePropertiesView({
  draft,
  siteShowChecked,
  siteBoxChecked,
  onChangeUpdateInput,
  onChangeCheckboxShow,
  onChangeCheckboxBox,
  onClickUpdate,
}: UpdatePropertiesViewProps) {
  return (
    <>
      <Row>
        <Col>
          {/* PROPERTY NAME */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Property Name
            </Label>
            <Col md="7">
              <InputGroup className="mb-2">
                <Input
                  placeholder="Update Property Name"
                  type="text"
                  name="name"
                  value={draft.name || ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* DESCRIPTION */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Property Description
            </Label>
            <Col md="7">
              <InputGroup>
                <Input
                  placeholder="Update Property Description"
                  type="text"
                  name="description"
                  value={draft.description || ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* TYPE */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Property Type
            </Label>
            <Col md="7">
              <InputGroup>
                <Input
                  placeholder="Update Property Type"
                  type="text"
                  name="type"
                  value={draft.type || ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* ORDER LISTING */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Order Listing
            </Label>
            <Col md="7">
              <InputGroup>
                <Input
                  placeholder="Update Order Listing"
                  type="text"
                  name="order_listing"
                  value={draft.order_listing || ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* ORDER PRODUCT */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Order Product
            </Label>
            <Col md="7">
              <InputGroup>
                <Input
                  placeholder="Update Order Product"
                  type="text"
                  name="order_product"
                  value={draft.order_product || ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* Show in listing */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Show In Listing
            </Label>
            <Col md="7">
              <InputGroup className={classnames("input-group-merge")}>
                <label className="custom-toggle custom-toggle-danger mr-1">
                  <input
                    name="show"
                    type="checkbox"
                    checked={!!siteShowChecked}
                    onChange={onChangeCheckboxShow}
                    aria-label="Show in listing"
                  />
                  <span
                    className="custom-toggle-slider rounded-circle"
                    data-label-off="No"
                    data-label-on="Yes"
                  />
                </label>
              </InputGroup>
            </Col>
          </FormGroup>

          {/* Show in details box */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Show In Details Box
            </Label>
            <Col md="7">
              <InputGroup className={classnames("input-group-merge")}>
                <label className="custom-toggle custom-toggle-danger mr-1">
                  <input
                    name="box"
                    type="checkbox"
                    checked={!!siteBoxChecked}
                    onChange={onChangeCheckboxBox}
                    aria-label="Show in details box"
                  />
                  <span
                    className="custom-toggle-slider rounded-circle"
                    data-label-off="No"
                    data-label-on="Yes"
                  />
                </label>
              </InputGroup>
            </Col>
          </FormGroup>

          {/* Update BUTTON */}
          <Col>
            <FormGroup style={{ right: 0, position: "absolute" }} className="row">
              <Button
                className="btn btn-outline-primary mr-1 float-right"
                color="primary"
                type="button"
                onClick={() => {
                  onClickUpdate();
                  NotificationAlertOptions("success", "Property Updated Successfully.");
                }}
              >
                Update Property
              </Button>
            </FormGroup>
          </Col>
        </Col>
      </Row>
    </>
  );
}
